import at from './at.mjs';
import selectors from './selectors.mjs';
import utilities from './utilities.mjs';
import animations from './animations.mjs';
import variables from './variables.mjs';
import rules from './rules.mjs';
import modes from './modes.mjs';
import functions from './functions.mjs';
import screens from './screens.mjs';

const config = {
    at,
    selectors,
    utilities,
    rules,
    functions,
    animations,
    variables,
    modes,
    screens,
    scope: '',
    rootSize: 16,
    baseUnit: 4,
    override: false,
    important: false,
    defaultMode: 'light'
};

export { animations, at, config, functions, modes, rules, screens, selectors, utilities, variables };
